import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    page: { backgroundColor: '#FFFFFF', padding: 30, fontFamily: 'Helvetica' },
    headerContainer: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, borderBottom: '2px solid #2C3E50', paddingBottom: 10 },
    headerTitle: { fontSize: 22, color: '#2C3E50', flex: 3, textAlign: 'left', fontFamily: 'Helvetica-Bold' },
    logo: { width: 60, height: 60, objectFit: 'contain' },
    section: { marginBottom: 15, padding: 15, border: '1px solid #EAEAEA', borderRadius: 5 },
    sectionTitle: { fontSize: 16, fontFamily: 'Helvetica-Bold', marginBottom: 10, color: '#18BC9C', borderBottom: '1px solid #EAEAEA', paddingBottom: 5 },
    row: { flexDirection: 'row', marginBottom: 6 },
    label: { fontSize: 11, width: '35%', fontFamily: 'Helvetica-Bold', color: '#34495E' },
    value: { fontSize: 11, width: '65%', color: '#7F8C8D' },
    valueDescription: { fontSize: 11, color: '#7F8C8D', lineHeight: 1.4 },
    footer: { position: 'absolute', bottom: 30, left: 30, right: 30, textAlign: 'center', color: 'grey', fontSize: 10 },
});

// Chad: Componente "a prueba de balas" mejorado. Asegura que el resultado siempre sea un string.
const SafeText = ({ style, children }) => {
    const content = children || 'No especificado';
    return <Text style={style}>{String(content)}</Text>;
};

const ProjectPDF = ({ proyecto, logoUrl }) => {
    const safeProyecto = proyecto || {};

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.headerContainer}>
                    <SafeText style={styles.headerTitle}>Ficha de Proyecto: {safeProyecto.nombreProyecto || 'Sin Nombre'}</SafeText>
                    {logoUrl ? <Image style={styles.logo} src={logoUrl} /> : null}
                </View>

                <View style={styles.section}>
                    <Text style={styles.sectionTitle}>Datos del Cliente</Text>
                    <View style={styles.row}>
                        <SafeText style={styles.label}>Nombre:</SafeText>
                        <SafeText style={styles.value}>{safeProyecto.nombreCliente}</SafeText>
                    </View>
                    <View style={styles.row}>
                        <SafeText style={styles.label}>Persona Contacto:</SafeText>
                        <SafeText style={styles.value}>{safeProyecto.personaContacto || safeProyecto.nombreCliente}</SafeText>
                    </View>
                    <View style={styles.row}>
                        <SafeText style={styles.label}>Teléfono:</SafeText>
                        <SafeText style={styles.value}>{safeProyecto.telefonoCliente}</SafeText>
                    </View>
                    <View style={styles.row}>
                        <SafeText style={styles.label}>Email:</SafeText>
                        <SafeText style={styles.value}>{safeProyecto.emailCliente}</SafeText>
                    </View>
                </View>

                <View style={styles.section}>
                    <Text style={styles.sectionTitle}>Detalles del Proyecto</Text>
                    <View style={styles.row}>
                        <SafeText style={styles.label}>Estado:</SafeText>
                        <SafeText style={styles.value}>{safeProyecto.estado}</SafeText>
                    </View>
                    <View style={styles.row}>
                        <SafeText style={styles.label}>Prioridad:</SafeText>
                        <SafeText style={styles.value}>{safeProyecto.prioridad}</SafeText>
                    </View>
                    <View style={styles.row}>
                        <SafeText style={styles.label}>Vendedor:</SafeText>
                        <SafeText style={styles.value}>{safeProyecto.vendedor}</SafeText>
                    </View>
                    <View style={styles.row}>
                        <SafeText style={styles.label}>Departamento:</SafeText>
                        <SafeText style={styles.value}>{safeProyecto.departamento}</SafeText>
                    </View>
                    <View style={styles.row}>
                        <SafeText style={styles.label}>Fecha de Entrega:</SafeText>
                        <SafeText style={styles.value}>{safeProyecto.fechaEntrega}</SafeText>
                    </View>
                    <View style={styles.row}>
                        <SafeText style={styles.label}>Ubicación:</SafeText>
                        <SafeText style={styles.value}>{safeProyecto.ubicacion}</SafeText>
                    </View>
                </View>
                
                {/* Chad: Corrección clave. Usamos un ternario para no renderizar un string vacío */}
                {safeProyecto.descripcion ? (
                    <View style={styles.section}>
                        <Text style={styles.sectionTitle}>Descripción</Text>
                        <SafeText style={styles.valueDescription}>{safeProyecto.descripcion}</SafeText>
                    </View>
                ) : null}
                
                <Text style={styles.footer}>
                    Documento generado por Hoppy Time App el {new Date().toLocaleDateString('es-ES')}
                </Text>
            </Page>
        </Document>
    );
};

export default ProjectPDF;